module.exports = __webpack_public_path__ + "img/how-it-works-hero-f211583.jpg";